export default "__VITE_ASSET__Yyu9AEVh__"